import i18n from '../i18n';
import { applyBrandToText } from './brand.config';

/** Public route path → i18n key under seo.routes */
export const SEO_ROUTE_I18N_KEYS: Record<string, string> = {
  '/': 'home',
  '/features': 'features',
  '/pricing': 'pricing',
  '/about': 'about',
  '/contact': 'contact',
  '/documentation': 'documentation',
  '/guide': 'guide',
  '/apps': 'apps',
  '/blog': 'blog',
  '/blog/tag': 'blogTag',
  '/login': 'login',
  '/register': 'register',
  '/verify-email': 'verifyEmail',
  '/2fa': 'twoFa',
  '/forgot-password': 'forgotPassword',
  '/reset-password': 'resetPassword',
  '/dashboard': 'dashboard',
  '/pay': 'pay',
};

const OG_LOCALES: Record<string, string> = {
  en: 'en_US',
  ar: 'ar_SA',
  zh: 'zh_CN',
  ko: 'ko_KR',
};

export function getOgLocale(lang?: string): string {
  const code = lang || i18n.language || 'en';
  return OG_LOCALES[code] || OG_LOCALES.en;
}

export function getOgLocaleAlternates(currentLang?: string): string[] {
  const lang = currentLang || i18n.language || 'en';
  return Object.entries(OG_LOCALES)
    .filter(([code]) => code !== lang)
    .map(([, locale]) => locale);
}

/** Title + description from active UI language (fallback: English). */
export function getSeoCopy(
  routeKey: string,
  lang?: string
): { title: string; description: string } | null {
  const lng = lang || i18n.language || 'en';
  const t = i18n.getFixedT(lng);
  const title = t(`seo.routes.${routeKey}.title`, { defaultValue: '' });
  const description = t(`seo.routes.${routeKey}.description`, { defaultValue: '' });
  if (!title && !description) return null;
  const desc =
    description ||
    t('seo.defaultDescription', {
      defaultValue: i18n.getFixedT('en')('seo.defaultDescription', { defaultValue: '' }),
    });
  return {
    title: applyBrandToText(title),
    description: applyBrandToText(desc),
  };
}

export function getDefaultDescription(lang?: string): string {
  const lng = lang || i18n.language || 'en';
  const t = i18n.getFixedT(lng);
  return applyBrandToText(
    t('seo.defaultDescription', {
      defaultValue: i18n.getFixedT('en')('seo.defaultDescription', { defaultValue: '' }),
    })
  );
}
